import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";

import { $gitDiffRefs } from "../../internal/git";

/**
 * Hook to get git diff between two refs
 * @param documentId - The document ID
 * @param aSide - The first ref to compare
 * @param bSide - The second ref to compare
 * @returns The git diff or undefined if not available
 */
export const useGitDiffRefs = (documentId: string | undefined, aSide: string, bSide: string) => {
	const diffRefsAtom = $gitDiffRefs({ documentId, aSide, bSide });
	const diffRefsLoadable = useAtomValue(loadable(diffRefsAtom));

	return {
		data: diffRefsLoadable.state === "hasData" ? diffRefsLoadable.data : undefined,
		isLoading: diffRefsLoadable.state === "loading",
		isError: diffRefsLoadable.state === "hasError",
	};
};
